import React from 'react';

export const VeteransBadge = ({ size = 'md' }) => {
  const titleCls = size === 'sm'
    ? 'text-[#143160] text-xs font-black tracking-tight'
    : 'text-[#143160] text-sm font-black tracking-tight';
  const subCls = size === 'sm'
    ? 'text-[#c41e3a] text-[10px] font-bold'
    : 'text-[#c41e3a] text-xs font-bold';
  const wrapperCls = size === 'sm'
    ? 'flex items-center space-x-2 bg-sand-50 rounded-lg px-3 py-2 shadow-lg'
    : 'flex items-center space-x-2 bg-sand-50 rounded-xl px-4 py-2 shadow-lg';

  return (
    <div className={wrapperCls}>
      <svg className="w-6 h-6 text-red-600" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" /></svg>
      <div className="flex flex-col">
        <span className={titleCls}>VETERANS UNITED</span>
        <span className={subCls}>Preferred Agent</span>
      </div>
    </div>
  );
};
